// Generated types for ActionParameter
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { FlowType } from '../enums';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ActionParameterReadAPI extends RFLPElementReadAPI {
  /** matter / energy / information (Pahl & Beitz). Must agree with the flow_type of the ItemFlows on this parameter (FLOW_TYPE_MISMATCH). */
  flow_type?: FlowType;
}

export interface ActionParameterWriteAPI extends RFLPElementWriteAPI {
  /** matter / energy / information (Pahl & Beitz). Must agree with the flow_type of the ItemFlows on this parameter (FLOW_TYPE_MISMATCH). */
  flow_type?: FlowType;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ActionParameterReadAPISchemaObject = RFLPElementReadAPISchemaObject.extend({
  flow_type: z.nativeEnum(FlowType).optional(),
}).passthrough();
export const ActionParameterReadAPISchema: z.ZodType<ActionParameterReadAPI> = ActionParameterReadAPISchemaObject;

export const ActionParameterWriteAPISchemaObject = RFLPElementWriteAPISchemaObject.extend({
  flow_type: z.nativeEnum(FlowType).optional(),
}).passthrough();
export const ActionParameterWriteAPISchema: z.ZodType<ActionParameterWriteAPI> = ActionParameterWriteAPISchemaObject;
